/*
Copyright (C) 2023-2026 QuantumNous

This program is free software: you can redistribute it and/or modify
it under the terms of the GNU Affero General Public License as
published by the Free Software Foundation, either version 3 of the
License, or (at your option) any later version.

This program is distributed in the hope that it will be useful,
but WITHOUT ANY WARRANTY; without even the implied warranty of
MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE. See the
GNU Affero General Public License for more details.

You should have received a copy of the GNU Affero General Public License
along with this program. If not, see <https://www.gnu.org/licenses/>.

For commercial licensing, please contact support@quantumnous.com
*/
import i18n from 'i18next'
import LanguageDetector from 'i18next-browser-languagedetector'
import { initReactI18next } from 'react-i18next'
import en from './locales/en.json'
import fr from './locales/fr.json'
import ja from './locales/ja.json'
import ru from './locales/ru.json'
import vi from './locales/vi.json'
import zh from './locales/zh.json'
import ar from './locales/ar.json'

export const resources = {
  en,
  zh,
  fr,
  ru,
  ja,
  vi,
  ar,
} as const

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'en',
    supportedLngs: ['zh', 'zh-Hant', 'en', 'fr', 'ru', 'ja', 'vi', 'ar'],
    // 改为 'all'：保留 zh-Hant 完整语种代码（languageOnly 会把 zh-Hant 折叠成 zh，
    // 导致模型目录无法区分繁体中文）。zh-CN 等仍会通过回退链落到 zh 资源。
    load: 'all',
    nsSeparator: false, // Allow literal colons in keys (e.g., URLs, labels)
    debug: import.meta.env.DEV,
    interpolation: {
      escapeValue: false, // not needed for react as it escapes by default
    },
    detection: {
      // 默认英文：首屏不再跟随浏览器语言，未手动选择时一律英文（fallbackLng='en'）。
      // 用户一旦在语言选择器选过，localStorage 会记住选择。
      order: ['localStorage'],
      caches: ['localStorage'],
    },
  })

export default i18n
